module.exports = __webpack_public_path__ + "img/html-evolution-7.5d8d8adf.webp";